import React from "react";

const Fallback = () => {
  return (
    <div style={{ display: "flex", justifyContent: "center" }}>
      Something went wrong.
    </div>
  );
};

export default Fallback;
